import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import find from "lodash/find"

import BidValue from "../../components/BidValue"
import i18n from "../../i18n"

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

const BidValuesWrapper = styled.div`
  padding-bottom: 40px;
  padding-left: 2px;
  padding-right: 2px;
  text-align: center;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
`

class BidNumbers extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedBidCount: 0,
    }
    this.getNumberWithDecimal = this.getNumberWithDecimal.bind(this)
    this.getClassName = this.getClassName.bind(this)
    this.handleOnClick = this.handleOnClick.bind(this)
    this.getFloatNumber = this.getFloatNumber.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selcetedBidNum !== this.props.selcetedBidNum) {
      this.setState({
        isBidSelect: false,
      })
    }
  }

  getNumberWithDecimal(selcetedBidNum, num) {
    let x = selcetedBidNum + num / 100
    if (selcetedBidNum.toString().length === 1) {
      return `0${x.toFixed(2)}`
    }
    return x.toFixed(2)
  }

  getClassName(index, preSelectedBidArr, bidValue, selectedBidValues) {
    let selectedBidObj = find(preSelectedBidArr, { bidValue: bidValue })
    if (selectedBidObj) {
      //if (selectedBidObj.isUnique) return "preSeletedUniqueFloatBid"

      if (selectedBidObj.bidHealth == "badBid") {
        return "preSeletedBadFloatBid"
      } else if (selectedBidObj.bidHealth == "goodBid") {
        return "preSeletedGoodFloatBid"
      } else if (selectedBidObj.bidHealth == "okBid") {
        return "preSeletedOkFloatBid"
      }

      return "preSeletedRepeatedFloatBid"
    } else if (selectedBidValues.indexOf(bidValue) > -1) {
      return "activeFloatBid"
    } else {
      return "inactiveFloatBid"
    }
  }

  handleOnClick({ index, floatingValue, className }) {
    const { showToast } = this.props
    if (className === "preSeletedRepeatedFloatBid") {
      showToast({
        text: i18n.t("RepeatedBidMsg"),
        variant: "info",
      })
    } else if (className === "preSeletedUniqueFloatBid") {
      showToast({
        text: i18n.t("UniqueBidMsg"),
        variant: "info",
      })
    } else {
      this.props.onSelectActualBidNum(index, floatingValue)
    }
  }

  getFloatNumber() {
    const { selcetedBidNum, preSelectedBid, selectedBidValues } = this.props
    var data = []
    for (var num = 0; num < 100; num++) {
      if (selcetedBidNum === 0 && num === 0) {
        continue
      }
      const floatingValue = this.getNumberWithDecimal(selcetedBidNum, num)
      const className = this.getClassName(
        num - 1,
        preSelectedBid,
        floatingValue,
        selectedBidValues
      )
      data.push(
        <BidValue
          key={num}
          className={className}
          number={floatingValue}
          onClick={() =>
            this.handleOnClick({ index: num - 1, floatingValue, className })
          }
        />
      )
    }
    return data
  }

  render() {
    console.log("BidNumbers props -->>", this.props)
    // const { selcetedBidNum, bidLowerRange, preSelectedBid, selectedBidValues } = this.props;
    // let bidsArray = [...bidLowerRange];
    // if(selcetedBidNum === 0){
    //     bidsArray.shift();
    // }
    return (
      <Container>
        <BidValuesWrapper>{this.getFloatNumber()}</BidValuesWrapper>
      </Container>
    )
  }
}

BidNumbers.defaultProps = {
  selcetedBidNum: 0,
}

BidNumbers.propTypes = {
  onSelectActualBidNum: PropTypes.func,
  selcetedBidNum: PropTypes.number,
  BidValues: PropTypes.array,
}

export default BidNumbers

// {
//     bidsArray.map((num, index)=> {
//         const floatingValue = this.getNumberWithDecimal(selcetedBidNum, num);
//         const className = this.getClassName(index, preSelectedBid, floatingValue, selectedBidValues);
//         return <BidValue
//             key={index}
//             className={className}
//             number={floatingValue}
//             onClick={()=> this.handleOnClick({index, floatingValue, className})}
//         />
//     })
// }



// WEBPACK FOOTER //
// ./src/views/PlaceBids/BidNumbers.js